import { render } from "./VerificationEmailSent.vue?vue&type=template&id=802c08bc"
import script from "./VerificationEmailSent.vue?vue&type=script&lang=js"
export * from "./VerificationEmailSent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__